import { useState, useContext } from 'react';
import papaparse from 'papaparse';
import lodash from 'lodash';
import { AppContext, EMPTY_STRING } from 'commons-ui';
import { useHistory } from 'react-router-dom';
import useService from '../utils/useService';
import { preparePredictWinContest, actionOptions } from '../utils';
import { IPredictAndWinV2Contest, ICsvToJson, IActionOptions } from '../model';

const useUpload = () => {
	const [csvFile, setCSVFile] = useState<File | null>(null);
	const [showLoader, setShowLoader] = useState(false);
	const [selectedAction, setSelectedAction] = useState([actionOptions[0]]);
	const { app, showAlert } = useContext(AppContext);
	const { requestCreatePredictWinContest, requestUpdatePredictWinContest } = useService();
	const history = useHistory();

	const handleActionChange = (value: IActionOptions[]) => {
		setSelectedAction(value);
	};

	const handleFileUpload = async (uploadedFiles: File[]) => {
		const file = lodash.first(uploadedFiles);
		if (!lodash.isEmpty(file)) await setCSVFile(file);
	};

	const CSVtoJSON = (csvText: string) => {
		const parsedData = papaparse.parse(csvText, { header: true, skipEmptyLines: true });
		return parsedData.data;
	};

	const createPredictWinContest = async (jsonData: ICsvToJson[]) => {
		if (!jsonData) return;
		setShowLoader(true);
		const contestDetails: IPredictAndWinV2Contest = preparePredictWinContest(jsonData);
		let resp;
		if (selectedAction?.[0]?.id === 'update') {
			resp = await requestUpdatePredictWinContest(app.appName, contestDetails);
		} else {
			resp = await requestCreatePredictWinContest(app.appName, contestDetails);
		}

		if (resp?.data?.success) showAlert('CSV upload successfully.', { type: 'success' });
		else
			showAlert(resp?.data?.externalMessage || 'some error ocurred while uploading csv', { type: 'error', duration: 'MEDIUM' });
		history.goBack();
	};

	const uploadCsvFile = () => {
		if (!csvFile) return;

		const reader = new FileReader();
		reader.onload = () => {
			const text: string = reader.result?.toString() || EMPTY_STRING;
			const data = CSVtoJSON(text);
			createPredictWinContest(data);
		};
		reader.readAsText(csvFile);
	};

	return {
		showLoader,
		showAlert,
		csvFile,
		selectedAction,
		handleFileUpload,
		uploadCsvFile,
		handleActionChange
	};
};

export default useUpload;
